<template>
  <div class="vertical-tabs--container" vertical>
    <asc-tab v-model="model" vertical>
      <asc-tab-title
        v-for="(item, index) in sideItems"
        :key="item.title + index"
        :title="item.title"
        vertical
      />
      <asc-accent-button
        v-if="showLink"
        button-text="Open in New Window"
        icon="mdi-open-in-new"
        icon-position="right"
        :on-click="handleNewWindow"
        secondary
      />
    </asc-tab>
    <slot></slot>
  </div>
</template>

<script>
import AscAccentButton from '@/components/atoms/AscAccentButton'
import AscTab from '@/components/atoms/AscTab'
import AscTabTitle from '@/components/atoms/AscTabTitle'

export default {
  name: 'VerticalTabs',

  components: {
    AscAccentButton,
    AscTab,
    AscTabTitle,
  },

  props: {
    showLink: {
      type: Boolean,
      default: true,
    },
    sideItems: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      activeTab: 0,
    }
  },

  computed: {
    model: {
      get() {
        return this.activeTab
      },
      set(newVal) {
        this.activeTab = newVal
        this.$emit('update:value', newVal)
        this.$emit('input', newVal)
      },
    },
  },

  watch: {
    value(newValue) {
      this.activeTab = newValue
    },
  },

  methods: {
    handleNewWindow() {},
  },
}
</script>

<style lang="scss">
.vertical-tabs--container {
  display: flex;
  flex-flow: row;
  min-height: 397px;

  .asc-vertical-tabs {
    width: 200px;

    .v-tabs-bar {
      width: 200px;
    }

    .asc-accent-button {
      background-color: $gray-100 !important;
      border: none;
      align-self: flex-end;
      width: 100%;
    }

    .asc-accent-button-container .asc-accent-button--accent .v-btn__content {
      color: $accent-700;
      text-transform: none;
      font-weight: normal;
    }
  }

  .asc-tab__content--primary,
  .asc-tab__content--secondary {
    width: 100%;
  }
}
</style>
